<router-outlet></router-outlet>
<ngx-smart-modal #marketingcauseModal identifier="marketingcauseModal" customClass="small-modal">
  <hire-feature [featureId]="'marketing-causa'" [name]="'Curso de Marketing de Causa'"
    [description]="'fazer o curso de Marketing de Causa '"></hire-feature>
</ngx-smart-modal>